import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default function usePagesList() {
    const isPagesFormSidebarActive = ref(false)
    const pagesData = ref(null);
    const pages = ref([]);

    const toast = useToast()
    const refCatListTable = ref(null);
    const tableColumns = [

        { key: '', label: '', sortable: false },
        { key: 'title', label: 'Title', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },


        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false },


    ]
    const perPage = ref(10)
    const totalPages= ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const statusFilter = ref(null)
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    
    const dataMeta = computed(() => {
      const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
      const to = Math.min(
        totalPages.value,
        perPage.value * currentPage.value
      );
      return {
        from,
        to,
        of: totalPages.value,
      }
    })
    
    const refetchData = () => {
        // refCatListTable.value.refresh()
        fetchData()
    }
    watch([currentPage, perPage, searchQuery, statusFilter], () => {
     
        fetchData()
    })
    const fetchData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);
        pages.value =[]
        store
          .dispatch('app-pages/fetchData', {
            limit: perPage.value,
            offset:offset,
            keywords: searchQuery.value, 
            order_by:'ordering_count desc, id ASC',
            sites_id: getLocalSite.id        
          })
          .then(response => {
           
            const  cats  = response.data.data
            pages.value = cats
            
            const total = response.data.total?response.data.total:cats.length;
            // callback(cats)
            totalPages.value = total
          })
          .catch((error) => {
            toast({
              component: ToastificationContent,
              props: {
                title: "Error fetching Category' list",
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
    }
    fetchData();
    const resolveCatStatusVariant = status => {
       
        if (status) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }
    const resolveCatStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }
    const updateData = (data)=>{
        pagesData.value = data;
        isPagesFormSidebarActive.value = true;
    }
    const deleteData = (id) => {
        store.dispatch('app-pages/deleteData',id).then(response=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Delete Success",
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
          refetchData();
        }).catch(()=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Error Delete Pages",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
    
        })
      }

      const updatePageOrdering  = async ()=>{

       await
        store.dispatch('app-pages/updatePageOrdering',pages.value)
        fetchData();
        
      }
      
    return {
        isPagesFormSidebarActive,
        pagesData,
        refCatListTable,
        tableColumns,
        perPage,
        totalPages,
        currentPage,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        statusFilter,
        dataMeta,
        pages,
        refetchData,
        fetchData,
        resolveCatStatusVariant,
        resolveCatStatusnameVariant,
        updateData,
        deleteData,
        updatePageOrdering
    

    }
}